import axios from "axios";
// import QS from "qs";

// if (process.env.NODE_ENV == "development") {
//   axios.defaults.baseURL =
//     localStorage.getItem("language") == "Chinese"
//       ? "http://antai.cn.135365.cn"
//       : "http://antai.en.135365.cn/";
//       console.log(localStorage.getItem("language"));
// } else if (process.env.NODE_ENV == "debug") {
//   axios.defaults.baseURL =
//     localStorage.getItem("language") == "Chinese"
//       ? "http://antai.cn.135365.cn"
//       : "http://antai.en.135365.cn/";
//       console.log(localStorage.getItem("language"));
// } else if (process.env.NODE_ENV == "production") {
//   axios.defaults.baseURL =

// }
// console.log(localStorage.getItem("language"));
axios.defaults.timeout = 10000;

axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";

// 响应拦截器
// 请求拦截器
// axios.interceptors.request.use(
//   error => {
//     return Promise.error(error);
//   }
// );

// 响应拦截器
axios.interceptors.response.use(
  response => {
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是200的情况
  error => {
    if (error.response.status) {
      switch (error.response.status) {
        // 404请求不存在
        case 404:
          this.$notify({
            message: "网络请求不存在",
            type: "warning"
          });
          break;
        // 其他错误，直接抛出错误提示
        default:
          this.$notify({
            message: error.response.data.msg
          });
      }
      return Promise.reject(error.response);
    }
  }
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    let baseUrl = "https://manage-en.antai-energy.com";
    axios
      .get(baseUrl + url, {
        params: params
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post(url, params) {
  return new Promise((resolve, reject) => {
    let baseUrl ="https://manage-en.antai-energy.com"
    axios
      .post(baseUrl + url, params)
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
}



// WEBPACK FOOTER //
// ./src/request/http.js